import { Typography } from '@mui/material';
import {
  GridColDef,
  getGridDateOperators,
  getGridStringOperators,
} from '@mui/x-data-grid-pro';

import { excludeValues } from '@/components/DataGrid/utils';
import { AuditLogEvent, auditLogEventLabels } from '@/models/audit.logs';
import { getFormattedDateTime } from '@/utils';

const createdAt = (): Partial<GridColDef> => ({
  field: 'createdAt',
  headerName: 'Date and time',
  flex: 1,
  minWidth: 160,
  renderCell: (params) => {
    return (
      <Typography
        variant="body2"
        display="flex"
        alignItems="center"
        height="100%"
      >
        {getFormattedDateTime(new Date(params.value).toISOString())}
      </Typography>
    );
  },
  filterOperators: getGridDateOperators(true).filter(
    excludeValues(['isAnyOf', 'isNotEmpty', 'isEmpty']),
  ),
});

const username = (): Partial<GridColDef> => ({
  field: 'username',
  headerName: 'User',
  flex: 1,
  minWidth: 150,
  renderCell: (params) => (
    <Typography
      variant="body2"
      display="flex"
      alignItems="center"
      height="100%"
    >
      {params.value}
    </Typography>
  ),
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isEmpty', 'isNotEmpty']),
  ),
});

const email = (): Partial<GridColDef> => ({
  field: 'createdBy.email',
  headerName: 'Email',
  flex: 1,
  minWidth: 200,
  renderCell: (params) => (
    <Typography
      variant="body2"
      display="flex"
      alignItems="center"
      height="100%"
    >
      {params.row.email || '-'}
    </Typography>
  ),
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isEmpty', 'isNotEmpty']),
  ),
});

const action = (): Partial<GridColDef> => ({
  field: 'event',
  headerName: 'Action',
  flex: 1,
  minWidth: 120,
  renderCell: (params) => {
    const eventType = params.row.action as AuditLogEvent;

    return (
      <Typography
        variant="body2"
        display="flex"
        alignItems="center"
        height="100%"
      >
        {auditLogEventLabels[eventType] || params.row.action}
      </Typography>
    );
  },
});

const ipAddress = (): Partial<GridColDef> => ({
  field: 'ipAddress',
  headerName: 'IP Address',
  flex: 1,
  minWidth: 130,
  renderCell: (params) => (
    <Typography
      variant="body2"
      display="flex"
      alignItems="center"
      height="100%"
    >
      {params.value}
    </Typography>
  ),
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isEmpty', 'isNotEmpty']),
  ),
});

const reason = (): Partial<GridColDef> => ({
  field: 'reason',
  headerName: 'Reason',
  flex: 1,
  minWidth: 180,
  renderCell: (params) => (
    <Typography
      variant="body2"
      display="flex"
      alignItems="center"
      height="100%"
    >
      {params.value || '-'}
    </Typography>
  ),
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isEmpty', 'isNotEmpty']),
  ),
});

export const auditLogsCols = () => {
  return {
    createdAt,
    username,
    email,
    action,
    ipAddress,
    reason,
  };
};
